import React, { useEffect, useState } from "react";
import {
  Play,
  Pause,
  SkipForward,
  SkipBackward,
  VolumeUp,
  Shuffle,
  ArrowRepeat,
} from "react-bootstrap-icons";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import MusicPlayer from "./MusicPlayer";
import { makeGetRequest } from "../../../utils/api";
import { urls } from "../../../utils/urls";
import MusicTimeLine from "./MusicTimeLine";
import { useNavigate, useSearchParams } from "react-router-dom";
import Button from "react-bootstrap/esm/Button";

function Music(props) {
  const delay = (ms) => new Promise((r) => setTimeout(r, ms));
  const [songList, setSongList] = useState([
    {
      id: 0,
      title: "",
      description: ``,
      media: "",
      genre: "",
      artist: "",
      image: "",
      duration: 0,
      playlist: 0,
    },
  ]);
  const [song, setSong] = useState();
  const [count, setCount] = useState(0);
  const [play, setPlay] = useState(false);
  const [volume, setVolume] = useState(0.5);
  const [shuffleT, setShuffleT] = useState(false);
  const [loopTrack, setLoopTrack] = useState(false);
  const [loopPlaylist, setLoopPlaylist] = useState(false);
  const [currTime, setCurrTime] = useState({
    min: "0",
    sec: "00",
  });
  const [time, setTime] = useState({
    min: "0",
    sec: "00",
  });
  const [intervalID, setIntervalID] = useState();
  const [seconds, setSeconds] = useState(0);

  //settings
  const [timer, setTimer] = useState();
  const [errorChecking, setErrorChecking] = useState();
  const [allowImages, setAllowImages] = useState(true);

  /**
  const handleSettings = async () => {
    const response = await makeGetRequest(
      urls.activitiesUserSettings,
      "",
      true
    );
    const settings = response.data[0];
    setAllowImages(settings.allow_images);
    setTimer(settings.timer);
    setErrorChecking(settings.error_checking);
  }; 

  useEffect(() => {
    handleSettings();
  }, []);
  */
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const handleMusicData = async () => {
    const response = await makeGetRequest(
      urls.music_player + "?playlist=" + searchParams.get("playlist"),
      "",
      true
    );
    const musicResources = response.data;
    setSongList(musicResources);
  };

  useEffect(() => {
    handleMusicData();
  }, []);

  useEffect(() => {
    if (play) {
      const intervalId = setInterval(() => {
        if (play) {
          setSeconds((prevSeconds) => prevSeconds + 1);
        }
      }, 1000);
      setIntervalID(intervalId);
      return () => clearInterval(intervalId);
    }
  }, [play]);

  const playPause = () => {
    setPlay(!play);
  };

  const songSkip = (direction) => {
    if (shuffleT === true) {
      setSeconds(0);
      setCount(Math.floor(Math.random() * songList.length));
    } else {
      if (direction === ">") {
        if (count + 1 >= songList.length) {
          setCount(0);
          setSeconds(0);
          if (loopPlaylist === true) {
            setPlay(true);
          } else {
            setPlay(false);
          }
        } else {
          setCount((prevCount) => prevCount + 1);
          setSeconds(0);
        }
      } else {
        if (count <= 0) {
          setCount(0);
          setSeconds(0);
        } else {
          setCount((prevCount) => prevCount - 1);
          setPlay(false);
          setSeconds(0);
        }
      }
    }
  };

  useEffect(() => {
    const sec = songList[count].duration;
    const min = Math.floor(sec / 60);
    const secRemain = Math.floor(sec % 60);
    if (secRemain < 10) {
      const zSecRemain = String(`0` + secRemain);
      setTime({
        min: min,
        sec: zSecRemain,
      });
    } else {
      setTime({
        min: min,
        sec: secRemain,
      });
    }
  }, [songList, count]);

  useEffect(() => {
    setSong(songList[count].media);
  }, [count]);

  useEffect(() => {
    const curMin = Math.floor(seconds / 60);
    const curSec = Math.floor(seconds % 60);
    if (curSec < 10) {
      const zCurSec = String(`0` + curSec);
      setCurrTime({ min: curMin, sec: zCurSec });
    } else {
      setCurrTime({ min: curMin, sec: curSec });
    }

    if ((currTime.min === time.min) & (currTime.sec === time.sec)) {
      if (loopTrack) {
        setSeconds(0);
      } else {
        songSkip(">");
      }
    }
  }, [seconds]);

  const navToSongSelect = () => {
    navigate("/music-selector");
  };

  const shuffleToggle = () => {
    setShuffleT(!shuffleT);
    if (loopTrack === true) {
      setLoopTrack(false);
    }
  };

  const loopPlaylistToggle = () => {
    setLoopPlaylist(!loopPlaylist);
  };

  const loopTrackToggle = () => {
    setLoopTrack(!loopTrack);
    if (shuffleT === true) {
      setShuffleT(false);
    }
  };

  return (
    <>
      <MusicPlayer
        url={songList[count].media}
        playing={play}
        volume={volume}
        loop={loopTrack}
      />
      <Button style={{ margin: "5px" }} onClick={() => navToSongSelect()}>
        Back to Song Select{" "}
      </Button>
      <Row>
        <Card style={{ width: "95%", marginLeft: "auto", marginRight: "auto" }}>
          {allowImages && (
            <Card.Img
              style={{
                marginTop: "10px",
                transition: "ease-in",
                minHeight: "200px",
                minWidth: "200px",
                maxWidth: window.innerHeight / 2 - 60,
                maxHeight: window.innerHeight / 2 - 60,
                marginRight: "auto",
                marginLeft: "auto",
              }}
              variant="top"
              src={songList[count].image}
            />
          )}

          <Card.Header style={{ textAlign: "center" }}>
            <Row>
              <Col style={{ textAlign: "left", width: "33%" }}>
                <Col>Playing: {songList[count].title}</Col>
                <Col>Artist: {songList[count].artist}</Col>
              </Col>
              <Col style={{ width: "66%" }}>
                <Row>
                  <Col>
                    {currTime.min}:{currTime.sec}
                  </Col>
                  <Col>
                    <MusicTimeLine
                      song={songList[count]}
                      seconds={seconds}
                      setSeconds={setSeconds}
                    />
                  </Col>
                  <Col>
                    {time.min}:{time.sec}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row style={{ height: "20px" }}>
              <Col style={{ textAlign: "left", marginLeft: "10px" }}>
                Track {count + 1}/{songList.length}
              </Col>
              <Col>
                <label htmlFor="volumeController">
                  <VolumeUp
                    style={{ fontSize: "25px", paddingBottom: "5px" }}
                  />
                </label>
                <input
                  style={{ marginTop: "7px" }}
                  type="range"
                  min="0"
                  id="volumeController"
                  default={volume}
                  className="timeline"
                  onChange={(e) => setVolume(e.target.value / 100)}
                />
              </Col>
            </Row>
          </Card.Header>
          <Row>
            <Col>
              {!loopTrack ? (
                <>
                  <Row style={{ fontSize: "34px", marginTop: "10px" }}>
                    <ArrowRepeat onClick={() => loopTrackToggle()} />
                    <div style={{ fontSize: "18px" }}>Loop Track: Off</div>
                  </Row>
                </>
              ) : (
                <>
                  <Row
                    style={{
                      fontSize: "34px",
                      color: "white",
                      backgroundColor: "#430076",
                      marginLeft: "auto",
                      marginRight: "auto",
                      minWidth: "80px",
                      borderRadius: "20px",
                      marginTop: "10px",
                    }}
                  >
                    <ArrowRepeat onClick={() => loopTrackToggle()} />
                    <div style={{ fontSize: "18px" }}>Loop Track: On</div>
                  </Row>
                </>
              )}
            </Col>
            <Col>
              {!shuffleT ? (
                <>
                  <Row style={{ fontSize: "34px", marginTop: "10px" }}>
                    <Shuffle onClick={() => shuffleToggle()} />
                    <div style={{ fontSize: "18px" }}>Shuffle: Off</div>
                  </Row>
                </>
              ) : (
                <>
                  <Row
                    style={{
                      fontSize: "34px",
                      color: "white",
                      backgroundColor: "#430076",
                      marginLeft: "auto",
                      marginRight: "auto",
                      minWidth: "80px",
                      borderRadius: "20px",
                      marginTop: "10px",
                    }}
                  >
                    <Shuffle onClick={() => shuffleToggle()} />
                    <div style={{ fontSize: "18px" }}>Shuffle: On</div>
                  </Row>
                </>
              )}
            </Col>
            <Col>
              {!loopPlaylist ? (
                <>
                  <Row style={{ fontSize: "34px", marginTop: "10px" }}>
                    <ArrowRepeat onClick={() => loopPlaylistToggle()} />
                    <div style={{ fontSize: "18px" }}>Loop Playlist: Off</div>
                  </Row>
                </>
              ) : (
                <>
                  <Row
                    style={{
                      fontSize: "34px",
                      color: "white",
                      backgroundColor: "#430076",
                      marginLeft: "auto",
                      marginRight: "auto",
                      minWidth: "80px",
                      borderRadius: "20px",
                      marginTop: "10px",
                    }}
                  >
                    <ArrowRepeat onClick={() => loopPlaylistToggle()} />
                    <div style={{ fontSize: "18px" }}>Loop Playlist: On</div>
                  </Row>
                </>
              )}
            </Col>
          </Row>
          <Row>
            <Card.Body style={{ fontSize: "50px" }}>
              <Row>
                <Col></Col>
                <Col>
                  <SkipBackward onClick={() => songSkip("<")} />
                </Col>
                <Col>
                  {!play && <Play onClick={() => playPause()} />}
                  {play && <Pause onClick={() => playPause()} />}
                </Col>
                <Col>
                  <SkipForward onClick={() => songSkip(">")} />
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ fontSize: "18px" }}>
                <Col></Col>
                <Col>Previous</Col>
                <Col>
                  {!play && "Play"}
                  {play && "Pause"}
                </Col>
                <Col>Next</Col>
                <Col></Col>
              </Row>
            </Card.Body>
          </Row>
        </Card>
      </Row>
    </>
  );
}

export default Music;
